/* 此次改动删除了产品资料节点，对应产品资料相关代码注释 删除后otherPointsGroup._children[0]默认往前推一位*/
import * as zrender from 'zrender'
let timeout;
export default {
  data() {
    return {
      $instance: null,
      w: 0,
      h: 0,
      arc: [140, 40],
      line_w: 0,
      num: 6,
      pointsGroup: null,
      otherPointsGroup: null,
      pointsGroup2: null,
      otherPointsGroup2: null,
    }
  },
  computed: {
    // 产品资料文件上传数量
    informationNum() {
      return this.spuInfo.informationNum
    },
    // 产品文案文件上传数量
    paperworkNum() {
      return this.spuInfo.paperworkNum
    }
  },
  methods: {
    zrenderInit() {
      setTimeout(() => {
        this.$instance = zrender.init(document.getElementById('zrenderEl'));
        this.w = this.$instance.getWidth();
        this.h = this.$instance.getHeight() - 25;
        this.line_w = this.w - 60;
        // 线下同款 5
        if(this.spuInfo.productTypeCode != 5) {
          this.drawLine();
          setTimeout(_=>{
            this.drawPoint();
            this.drawOherPoints();
            this.drawDesc();
            this.renderActive();
          },500)
        }else{
          this.drawLine2();
          setTimeout(_=>{
            this.drawPoint2();
            this.drawOherPoints2();
            this.drawDesc2();
            this.renderActive2();
          },500)
        }
      }, 800);
    },
    drawLine() {
      let h = this.h;
      // 中间拐弯处区域的宽度，高度
      let arc = this.arc;
      let item_w = this.line_w / (this.num - 1);
      var g = new zrender.Group();
      const line1 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2],
            [1.5*item_w + 30,h/2],
            [1.5*item_w + 30,h/2],
            [2.5*item_w + 30,h/2],
            [2.5*item_w + 30,h/2],
            [5*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      const line2 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2],
            [1.5*item_w + 30,h/2],
            [1.5*item_w + 30,h/2],
            [2.5*item_w + 30,h/2],
            [2.5*item_w + 30,h/2],
            [5*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      // exponentialOut
      line1.animate('shape', false)
      .when(500, {
        points: [
          [0*item_w + 30,h/2],
          [1.5*item_w + 30,h/2],
          [1.5*item_w + 30,h/2+arc[1]],
          [2.5*item_w + 30,h/2+arc[1]],
          [2.5*item_w + 30,h/2],
          [5*item_w + 30,h/2]
        ]
      })
      .start();
      line2.animate('shape', false)
      .when(500, {
        points: [
          [0*item_w + 30,h/2],
          [1.5*item_w + 30,h/2],
          [1.5*item_w + 30,h/2-arc[1]],
          [2.5*item_w + 30,h/2-arc[1]],
          [2.5*item_w + 30,h/2],
          [5*item_w + 30,h/2]
        ]
      })
      .start();
      // line1.animateTo({
      //     shape: {
      //       points: [
      //         [0*item_w + 30,h/2],
      //         [2.5*item_w + 30,h/2],
      //         [2.5*item_w + 30,h/2+arc[1]],
      //         [3.5*item_w + 30,h/2+arc[1]],
      //         [3.5*item_w + 30,h/2],
      //         [7*item_w + 30,h/2]
      //       ]
      //     }
      // }, 10000, 100, 'exponentialOut', function () {
      //     // done
      // });
      // line2.animateTo({
      //     shape: {
      //       points: [
      //         [0*item_w + 30,h/2],
      //         [2.5*item_w + 30,h/2],
      //         [2.5*item_w + 30,h/2-arc[1]],
      //         [3.5*item_w + 30,h/2-arc[1]],
      //         [3.5*item_w + 30,h/2],
      //         [7*item_w + 30,h/2]
      //       ]
      //     }
      // }, 10000, 100, 'exponentialOut', function () {
      //     // done
      // });
      const line3 = new zrender.Polyline({
        shape: {
          points: [
            [1*item_w + 30,h/2 - this.arc[1]],
            [2.5*item_w + 30,h/2 - this.arc[1]],
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      //渲染起始虚线从开始制作画
      const line4 = new zrender.Polyline({
        shape: {
          points: [
            [1*item_w + 30,h/2 + this.arc[1] + 10],
            [0 *item_w + 30,h/2 + this.arc[1] + 10],
            [0*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      //渲染结束虚线从切片往左向开始虚线合并
      const line5 = new zrender.Polyline({
        shape: {
          points: [
            [1*item_w + 30,h/2 + this.arc[1] + 10],
            [2.7 *item_w + 30,h/2 + this.arc[1] + 10],
            [2.7*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      g.add(line1);
      g.add(line2);
      // g.add(line3);
      g.add(line4);
      g.add(line5);
      this.$instance.add(g);
    },
    drawPoint() {
      // 节点个数
      const num = this.num;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y+10]
        });
      }
      const skipTilte = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: '跳',
            fill: '#fff'
          }
        }).attr({
          position: [ x + text.length*6 + 5 ,y+10]
        });
      }
      
      const skip = (x, y, text) => {
        console.log(text,x);
        let tag = new zrender.Circle({
          shape: {
            cx: x + text.length * 6 + 11,
            cy: y,
            r: 1
          },
          style: {
            fill: '#81D3F8'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 10
        }).start();
        return tag;
      }
      let texts = ['开始制作','拍摄','修片','切片','准备上架','完成上架'];
      // ("跳过节点:0不跳过,1产品文案,2设计,3产品资料, 4样品组货, 5拍摄, 6修片, 7渲染"
      for(let i = 0; i < num; i++) {
        if(i == 2) {
          g.add(dot(item_w*i,this.arc[1]));
          g2.add(title(item_w*i,0,texts[i]).attr({
            position: [2*item_w - 12, 50]
          }));
          if(this.isJumpTrimming) {
            g2.add(skip(item_w*i,this.arc[1]+15,texts[i]));
            g2.add(skipTilte(item_w*i,this.arc[1],texts[i]));
          }
        }else{
          g.add(dot(item_w*i,0));
          g2.add(title(item_w*i,0,texts[i]));
          if(i == 1 && this.skipSum && this.skipSum.includes('5')){
            g2.add(skip(item_w*i,15,texts[i]));
            g2.add(skipTilte(item_w*i,0,texts[i]));
          }
        }
      }
      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.pointsGroup = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawOherPoints() {
      // 节点个数
      const num = this.num;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y - this.arc[1] + 10]
        });
      }

      const skipTilte = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: '跳',
            fill: '#fff'
          }
        }).attr({
          position: [ x + text.length*6 + 5 ,y - this.arc[1] + 10]
        });
      }
      
      const skip = (x, y, text) => {
        console.log(text,x);
        let tag = new zrender.Circle({
          shape: {
            cx: x + text.length * 6 + 11,
            cy: y,
            r: 1
          },
          style: {
            fill: '#81D3F8'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 10
        }).start();
        return tag;
      }
      // g.add(dot(item_w*1,-this.arc[1]));
      // g2.add(title(item_w*1,0,'产品资料'));
      // if(this.isJumpInformation) { //跳过产品资料才展示跳过标注
      //   g2.add(skip(item_w*1,-this.arc[1] + 15,'产品资料'));
      //   g2.add(skipTilte(item_w*1,0,'产品资料'));
      // }
      g.add(dot(item_w*2,-this.arc[1]));
      g2.add(title(item_w*2,0,'产品文案'));
      
      if(this.isJumpPaperWork) {  //跳过了产品文案才展示跳过标注
        g2.add(skip(item_w*2,-this.arc[1] + 15,'产品文案'));
        g2.add(skipTilte(item_w*2,0,'产品文案'));
      }
      g.add(dot(item_w*1.3,this.arc[1]+10));
      g2.add(title(item_w*1.3,this.arc[1] + 50,'渲染'));
      if(this.isJumpRender) { //跳过了渲染才展示跳过标注
        g2.add(skip(item_w*1.3,this.arc[1] + 25,'渲染'));
        g2.add(skipTilte(item_w*1.3,this.arc[1] + 50,'渲染'));
      }
      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.otherPointsGroup = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawDesc() {
      console.log(this.stepDescription);
      // 节点个数
      const num = this.num;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      const renderDesc = (x, y, text) => {
        if(!text) return null;
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*9/2 ,y+25]
        });
      }
      // 开始制作
      g.add(renderDesc(0*item_w, 0, this.stepDescription['newArrival']));
      // 拍摄
      g.add(renderDesc(1*item_w, 0, this.stepDescription['shooting']));
      // 修片
      g.add(renderDesc(2*item_w, this.arc[1], this.stepDescription['retouching']));
      // 产品资料
      // g.add(renderDesc(1*item_w, -this.arc[1], this.stepDescription['files']));
      // 产品文案
      g.add(renderDesc(2*item_w, -this.arc[1], this.stepDescription['paperwork']));
      // 切片
      g.add(renderDesc(3*item_w, 0, this.stepDescription['sectioning']));
      // 准备上架
      g.add(renderDesc(4*item_w, 0, this.stepDescription['preparation']));
      // 完成上架
      g.add(renderDesc(5*item_w, 0, this.stepDescription['finished']));
      // 渲染
      g.add(renderDesc(1.3*item_w, this.arc[1] - 35, this.renderNum));
      
      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      
      this.$instance.add(g);
    },
    renderActive() {
      let newSkuData = this.skuList.find(v=>v.taskId == this.currentStep)
      let activeStepIndex = this.activeStepIndex;
      for(let i = 0; i < activeStepIndex + 1; i++) {
        this.pointsGroup._children[i].attr({
          style: {
            // 走过的节点标绿，正在进行的节点标黄
            fill: i < activeStepIndex ? '#0BB78E' : '#FF9F1C'
          }
        })
        // 完成上架后，全部节点变为绿色
        if(activeStepIndex == 5 && newSkuData.isComplete) {
          this.pointsGroup._children[5].attr({
            style: {
              fill: '#0BB78E'
            }
          })
        }else if( activeStepIndex == 5 && !newSkuData.isComplete){
          this.pointsGroup._children[5].attr({
            style: {
              fill: '#FF9F1C'
            }
          })
        }
      }

      // 特殊逻辑判断
      // 当修片完成后，产品资料没有维护的话，当前节点id则变为105,
      if(this.currentStep === this.stepEnum.files) {
        // 产品资料节点标黄
        // this.otherPointsGroup._children[0].attr({
        //   style: {
        //     fill: '#FF9F1C'
        //   }
        // })
        // 修片节点标绿
        this.pointsGroup._children[2].attr({
          style: {
            fill: '#0BB78E'
          } 
        })
      }else{
        // if(this.informationNum > 0) {
        //   this.otherPointsGroup._children[0].attr({
        //     style: {
        //       // 当前节点如果为105
        //       fill: '#0BB78E'
        //     }
        //   })
        // }
      }

      // 特殊逻辑判断
      // 当修片完成后，产品资料已维护，产品文案没有维护的话，当前节点id则变为106,
      if(this.currentStep === this.stepEnum.paperwork) {
        // 产品文案节点标黄
        this.otherPointsGroup._children[0].attr({
          style: {
            fill: '#FF9F1C'
          }
        })
        // 修片节点标绿
        this.pointsGroup._children[2].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }else{
        if(this.paperworkNum > 0) {
          this.otherPointsGroup._children[0].attr({
            style: {
              // 当前节点如果为105
              fill: '#0BB78E'
            }
          })
        }
      }
      // 判断SPU是够跳过了流程节点，跳过了贼产品资料和产品文案都默认标绿
      if(this.spuInfo.isSkipTask > 0 && this.isJumpPaperWork) {
        this.otherPointsGroup._children[0].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }
      // if(this.spuInfo.isSkipTask == 3 || this.isJumpInformation) {
      //   this.otherPointsGroup._children[0].attr({
      //     style: {
      //       fill: '#0BB78E'
      //     }
      //   })
      // }
      //判断渲染节点是否跳过
      if(this.isJumpRender || this.isCompleteRendering) {
        this.otherPointsGroup._children[1].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }
      //判断渲染计划是否完成开始渲染标黄
      if(this.isCompleteRenderStart && !this.isCompleteRendering && this.renderPlan) {
        this.otherPointsGroup._children[1].attr({
          style: {
            fill: '#FF9F1C'
          }
        })
      }
    },
    /**
     * 线下同款
     */
    drawLine2() {
      let h = this.h;
      let num = 5
      // 中间拐弯处区域的宽度，高度
      let arc = this.arc;
      let item_w = this.line_w / (num - 1);
      var g = new zrender.Group();
      const line1 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2],
            [4*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      const line2 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2],
            [4*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2'
        }
      })
      const line3 = new zrender.Polyline({
        shape: {
          points: [
            [0*item_w + 30,h/2 - this.arc[1]],
            [1*item_w + 30,h/2 - this.arc[1]],
            [1*item_w + 30,h/2 - 0],
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      //渲染起始虚线从开始制作画
      const line4 = new zrender.Polyline({
        shape: {
          points: [
            [0.6*item_w + 30,h/2 + this.arc[1]],
            [0 *item_w + 30,h/2 + this.arc[1]],
            [0*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      //渲染结束虚线从切片往左向开始虚线合并
      const line5 = new zrender.Polyline({
        shape: {
          points: [
            [0.6*item_w + 30,h/2 + this.arc[1]],
            [1.2 *item_w + 30,h/2 + this.arc[1]],
            [1.2*item_w + 30,h/2]
          ]
        },
        style: {
          fill: 'transparent',
          stroke: '#e2e2e2',
          lineDash: [5,5]
        }
      })
      g.add(line1);
      g.add(line2);
      // g.add(line3);
      g.add(line4);
      g.add(line5);
      this.$instance.add(g);
    },
    drawPoint2() {
      // 节点个数
      const num = 5;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y+10]
        });
      }
      const skipTilte = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: '跳',
            fill: '#fff'
          }
        }).attr({
          position: [ x + text.length*6 + 5 ,y+10]
        });
      }
      const skip = (x, y, text) => {
        console.log(text,x);
        let tag = new zrender.Circle({
          shape: {
            cx: x + text.length * 6 + 11,
            cy: y,
            r: 1
          },
          style: {
            fill: '#81D3F8'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 10
        }).start();
        return tag;
      }
      let texts = ['开始制作','切片','准备上架','完成上架'];
      g.add(dot(0,0));
      g2.add(title(0,0,texts[0]));
      g.add(dot(2*item_w,0));
      g2.add(title(2*item_w,0,texts[1]));
      g.add(dot(3*item_w,0));
      g2.add(title(3*item_w,0,texts[2]));
      g.add(dot(4*item_w,0));
      g2.add(title(4*item_w,0,texts[3]));

      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.pointsGroup2 = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawOherPoints2() {
      // 节点个数
      const num = 5;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      var g2 = new zrender.Group();
      const dot = (x, y) => {
        let tag = new zrender.Circle({
          shape: {
            cx: x,
            cy: y,
            r: 1
          },
          style: {
            fill: '#8D99AE'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 5
        }).start();
        return tag;
      }
      const title = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*12/2 ,y - this.arc[1] + 10]
        });
      }

      const skipTilte = (x, y, text) => {
        return new zrender.Text({
          style: {
            text: '跳',
            fill: '#fff'
          }
        }).attr({
          position: [ x + text.length*6 + 5 ,y - this.arc[1] + 10]
        });
      }
      
      const skip = (x, y, text) => {
        console.log(text,x);
        let tag = new zrender.Circle({
          shape: {
            cx: x + text.length * 6 + 11,
            cy: y,
            r: 1
          },
          style: {
            fill: '#81D3F8'
          }
        })
        tag.animate('shape', false)
        .when(500, {
          r: 10
        }).start();
        return tag;
      }
        
      // g.add(dot(0,-this.arc[1]));
      // g2.add(title(0,0,'产品资料'));
      // if(this.isJumpInformation) { //跳过产品资料才展示跳过标注
      //   g2.add(skip(item_w*0,-this.arc[1] + 15,'产品资料'));
      //   g2.add(skipTilte(item_w*0,0,'产品资料'));
      // }

      g.add(dot(item_w*1,0));
      g2.add(title(item_w*1,10,'产品文案'));
      if(this.isJumpPaperWork) {  //跳过了产品文案才展示跳过标注
        g2.add(skip(item_w*1,-this.arc[1] + 25,'产品文案'));
        g2.add(skipTilte(item_w*1,10,'产品文案'));
      }

      g.add(dot(item_w*0.8,this.arc[1]));
      g2.add(title(item_w*0.8,this.arc[1] + 40,'渲染'));
      if(this.isJumpRender) { //跳过了渲染才展示跳过标注
        g2.add(skip(item_w*0.8,this.arc[1] + 15,'渲染'));
        g2.add(skipTilte(item_w*0.8,this.arc[1] + 40,'渲染'));
      }

      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      g2.position[0] = start_coordinate_x;
      g2.position[1] = coordinate_y;
      
      this.otherPointsGroup2 = g;
      this.$instance.add(g);
      this.$instance.add(g2);
    },
    drawDesc2() {
      // 节点个数
      const num = 5;
      // 起始点x坐标
      const start_coordinate_x = (this.w - this.line_w) / 2;
      // 纵坐标
      const coordinate_y = this.h / 2;
      // 两点之间的间隔距离
      let item_w = this.line_w / (num-1);
      var g = new zrender.Group();
      const renderDesc = (x, y, text) => {
        if(!text) return null;
        return new zrender.Text({
          style: {
            text: text,
            fill: '#999'
          }
        }).attr({
          position: [x - text.length*9/2 ,y+25]
        });
      }
      // 开始制作
      g.add(renderDesc(0*item_w, 0, this.stepDescription['newArrival']));
      // 产品资料
      g.add(renderDesc(0*item_w, -this.arc[1], this.stepDescription['files']));
      // 产品文案
      g.add(renderDesc(1*item_w, -15, this.stepDescription['paperwork']));
      // 切片
      g.add(renderDesc(2*item_w, 0, this.stepDescription['sectioning']));
      // 准备上架
      g.add(renderDesc(3*item_w, 0, this.stepDescription['preparation']));
      // 完成上架
      g.add(renderDesc(4*item_w, 0, this.stepDescription['finished']));
      // 渲染
      g.add(renderDesc(0.8*item_w, this.arc[1] - 45 , this.renderNum));
      
      g.position[0] = start_coordinate_x;
      g.position[1] = coordinate_y;
      
      this.$instance.add(g);
    },
    renderActive2() {
      let newSkuData = this.skuList.find(v=>v.taskId == this.currentStep)
      let mapNode = {
        [this.stepEnum.newArrival]: 0,
        [this.stepEnum.sectioning]: 1,
        [this.stepEnum.preparation]: 2,
        [this.stepEnum.finished]: 3,
      }
      let activeStepIndex = mapNode[this.currentStep]
      for(let i = 0; i < activeStepIndex + 1; i++) {
        this.pointsGroup2._children[i].attr({
          style: {
            // 走过的节点标绿，正在进行的节点标黄
            fill: i < activeStepIndex ? '#0BB78E' : '#FF9F1C'
          }
        })
        // 完成上架后，全部节点变为绿色
        if(activeStepIndex == 3 && newSkuData.isComplete) {
          this.pointsGroup2._children[3].attr({
            style: {
              fill: '#0BB78E'
            }
          })
        }else if(activeStepIndex == 3 && !newSkuData.isComplete){
          this.pointsGroup2._children[3].attr({
            style: {
              fill: '#FF9F1C'
            }
          })
        }
      }

      // 特殊逻辑判断
      // 当修片完成后，产品资料没有维护的话，当前节点id则变为105,
      if(this.currentStep === this.stepEnum.files) {
        // 产品资料节点标黄
        // this.otherPointsGroup2._children[0].attr({
        //   style: {
        //     fill: '#FF9F1C'
        //   }
        // })
        // 开始制作标绿
        this.pointsGroup2._children[0].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }else{
        // if(this.informationNum > 0 || this.isJumpPaperWork) {
        // if(this.informationNum > 0 || this.isJumpInformation) {
        //   this.otherPointsGroup2._children[0].attr({
        //     style: {
        //       // 当前节点如果为105
        //       fill: '#0BB78E'
        //     }
        //   })
        // }
      }

      // 特殊逻辑判断
      // 当修片完成后，产品资料已维护，产品文案没有维护的话，当前节点id则变为106,
      if(this.currentStep === this.stepEnum.paperwork) {
        // 产品文案节点标黄
        this.otherPointsGroup2._children[0].attr({
          style: {
            fill: '#FF9F1C'
          }
        })
        // 开始制作标绿
        this.pointsGroup2._children[0].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }else{
        if(this.paperworkNum > 0 || this.isJumpPaperWork) {
          this.otherPointsGroup2._children[0].attr({
            style: {
              // 当前节点如果为105
              fill: '#0BB78E'
            }
          })
        }
      }
      if(this.spuInfo.isSkipTask > 0 && this.isJumpPaperWork) {
        this.otherPointsGroup2._children[0].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }
      // if(this.spuInfo.isSkipTask == 3 || this.isJumpInformation) {
      //   this.otherPointsGroup2._children[0].attr({
      //     style: {
      //       fill: '#0BB78E'
      //     }
      //   })
      // }
      //判断渲染节点是否跳过
      if(this.isJumpRender || this.isCompleteRendering) {
        this.otherPointsGroup2._children[1].attr({
          style: {
            fill: '#0BB78E'
          }
        })
      }
      //判断是否完成开始渲染
      if(this.isCompleteRenderStart && !this.isCompleteRendering && this.renderPlan) {
        this.otherPointsGroup2._children[1].attr({
          style: {
            fill: '#FF9F1C'
          }
        })
      }
    },
    
  },
  watch: {
    // activeStepIndex: {
    //   handler(val) {
    //     console.log(val);
    //     if(timeout) clearTimeout(timeout);
    //     let callNow = !timeout;
    //     timeout = setTimeout(_=>{
    //       timeout = null;
    //     },1000);
    //     if(callNow) this.zrenderInit()
    //   },
    //   immediate: true
    // }
  }
}